import React from 'react';
import PropTypes from 'prop-types';

import Button from "UI/Button";
import Middle from "../Middle";
import NewSlideDialog from "../NewSlideDialog";
import AddSlideButton from "Components/AddSlideButton";

export default class BlankEditor extends React.Component
{
    state = {
        open: false
    };

    static propTypes = {
        storyId: PropTypes.string.isRequired,
        changeSlide: PropTypes.func.isRequired
    };

    render()
    {
        return <Middle>
            <div className='space-y-4'>
                <AddSlideButton
                    storyId={this.props.storyId}
                    selectSlide={this.props.changeSlide}
                />
            </div>
        </Middle>;
    }
}
